<template>
    <div v-if="currentOrder"
         id="order-details-vue">
        <OrderDetailsLeftCol />
        <OrderDetailsRightCol />
    </div>
</template>

<script>
// Note: This component is used as a dynamic component and appears inside #epos-vue-app but the child components
// both <Teleport> and appear elsewhere on the page. This means that we can just manage and enable this component
// instead of having to handle the two child components independently.
import EventNames from '@/lib/Events/EventNames';
import OrderDetailsLeftCol from '@/epos/vue/pages/order-details/components/OrderDetailsLeftCol';
import OrderDetailsRightCol from '@/epos/vue/pages/order-details/components/OrderDetailsRightCol';
import { container } from '@/container';
import { mapState } from 'vuex';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { timeoutPromise } from '@/functions/functions';

export default {
    name: 'OrderDetailsView',

    components: {
        OrderDetailsLeftCol,
        OrderDetailsRightCol,
    },

    computed: {
        // orderDetails/currentOrder is set by the Angular OrderDetailCtrl.
        ...mapState(
            'orderDetails',
            [
                'currentOrder',
                'currentOrderIsFromBarcodeScan',
            ]
        ),
    },

    watch: {
        currentOrder: {
            handler() {
                this.displayOutstandingBalanceModalAfterOrderScan();
            },
            immediate: true,
        },
    },

    beforeUnmount() {
        // Close any existing modals.
        container.vueModalFactory.closeAllOfType(MODAL_NAMES__EPOS.ORDER_OUTSTANDING_BALANCE);
    },

    methods: {
        async displayOutstandingBalanceModalAfterOrderScan() {
            // Close any existing modals.
            container.vueModalFactory.closeAllOfType(MODAL_NAMES__EPOS.ORDER_OUTSTANDING_BALANCE);

            // Small timeout because the currentOrderIsFromBarcodeScan flag is set after the order is set.
            await timeoutPromise(1);

            // You can't pay the balance for a cancelled or voided order, so don't show the modal in that case.
            if (!this.currentOrder || !this.currentOrder.isLive() || !this.currentOrderIsFromBarcodeScan) {
                return;
            }

            if (!this.currentOrder.fullyPaid && !this.currentOrder.overpaid) {
                container.vueModalFactory.open(
                    MODAL_NAMES__EPOS.ORDER_OUTSTANDING_BALANCE,
                    {
                        order: this.currentOrder,
                    }
                ).then((result) => {
                    if (result) {
                        container.eventBus.broadcast(
                            EventNames.PAY_ORDER_BALANCE_REQUESTED,
                            {
                                isRefund: false,
                            }
                        );
                    }
                });
            }
        },
    },
};
</script>
